import { useHierarchicalMenu } from 'react-instantsearch';
import { useIdentity } from '../../hooks';
import { trackEvent } from '../../utils/analytics';
import HierarchicalMenuFilter from '../product-search/shared/HierarchicalMenuFilter';

function CustomHierarchicalMenu({ label, onShowMore, ...props }) {
  const {
    items,
    isShowingMore,
    canToggleShowMore,
    refine,
    toggleShowMore,
  } = useHierarchicalMenu(props);
  const identity = useIdentity();

  const onRefine = (value) => {
    trackEvent('click_category', {
      tenant_id: identity.tenant_id,
      login_email: identity.login_email,
      category: value,
    });
    refine(value);
  };

  return (
    <HierarchicalMenuFilter
      label={label}
      items={items}
      onRefine={onRefine}
      canToggleShowMore={canToggleShowMore}
      isShowingMore={isShowingMore}
      onToggleShowMore={toggleShowMore}
      limit={props.limit}
      onShowMore={onShowMore}
    />
  );
}

export default CustomHierarchicalMenu;
